import { MarginWrapper } from '@travelnest/merlin.spacer';
import * as React from 'react';
import { ICommissionBreakdownObject } from '../../../data/entities/commission-breakdown';
import { IBookingBreakdown } from '../../../data/entities/event/booking';
import { IAppliedPromotion } from '../../../data/entities/promotions';
import { FormInput } from '../form';
import { Table, Tbody, Td, Tr } from '../table';
import { generateFeesRows } from './helpers';

interface IOwnerFeeBreakdownProps {
	breakdown: IBookingBreakdown;
	currencySymbol: string;
	appliedPromotions: IAppliedPromotion[];
	commissionBreakdown: ICommissionBreakdownObject;
}

/**
 * Table that breaks down commission (Called Fees to customers)
 *
 * @param breakdown
 * @param currencySymbol
 * @constructor
 */
export const OwnerFeeBreakdown: React.FC<IOwnerFeeBreakdownProps> = ({ breakdown, appliedPromotions, currencySymbol, commissionBreakdown }) => {
	const feeRowsData = generateFeesRows(breakdown, appliedPromotions, commissionBreakdown);
	return (
		<div className="booking-list__section">
			<h2>Fees</h2>
			<Table className="booking-breakdown-internal fees">
				<Tbody>
					{feeRowsData.map((feeRow) => (
						<Tr key={feeRow.name}>
							{feeRow.isPromotionalCommissionAdjustment === true
								? <Tr>
									<Td className="booking-breakdown__table-cell--wide">
										<MarginWrapper>{`Includes - ${feeRow.name}`}</MarginWrapper>
									</Td>
									{feeRow.rate === null ? <Td /> :
										<Td className="booking-breakdown__table-cell--slight-wide">
											<FormInput
												value={feeRow.rate ? `${feeRow.rate * 100}%` : '-'}
												readOnly
											/>
										</Td>
									}
									<Td className="booking-breakdown__table-cell--slight-wide">
										<FormInput
											value={`${currencySymbol} ${feeRow.val ? feeRow.val.toFixed(2) : '-'}`}
											readOnly
										/>
									</Td>
								</Tr>
								: <Tr>
									<Td className="booking-breakdown__table-cell--slight-wide">{feeRow.name}</Td>
									{feeRow.rate === null ? <Td /> :
										<Td className="booking-breakdown__table-cell--slight-wide">
											<FormInput
												value={feeRow.rate ? `${feeRow.rate * 100}%` : '-'}
												readOnly
											/>
										</Td>
									}
									<Td className="booking-breakdown__table-cell--slight-wide">
										<FormInput
											value={`${currencySymbol} ${feeRow.val ? feeRow.val.toFixed(2) : '-'}`}
											readOnly
										/>
									</Td>
								</Tr>
							}
						</Tr>
					))}
				</Tbody>
			</Table>
		</div>
	);
};
